import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './DesertSafariAndJeepTours.scss';
// import { FiChevronRight } from 'react-icons/fi';
import { LuClock9 } from "react-icons/lu";
import { IoLocationSharp } from "react-icons/io5";
import { ImCross } from "react-icons/im";
import { Helmet } from "react-helmet";
import emailjs from "@emailjs/browser";
import { FiChevronRight, FiShield, FiDollarSign, FiUsers, FiCalendar, FiClock, FiStar, FiCheckCircle } from "react-icons/fi";
import ReviewsSection from '../Review/Reviews';


import Itinerary from '../Itinerary/Itinerary';
import InclusionExclusion from '../InclusionAndExclusion/InclusionExclusion';
import FAQs from '../FAQs/FAQs';
import Map from '../Map/Map';
import Side from '../../../Side/side';
import Overview from '../Overview/Overview';
import { getTripBySlug } from '../../../../../../services/tripServices';
import { IMAGE_BASE_URL } from '../../../../../../config';
import Variations from '../Variations/variation';
import DateSelector from '../../../../../Booking/DateSelector/DateSelector';
import { Elements } from '@stripe/react-stripe-js';
import { stripePromise } from '../../../../../../stripe';
import CheckoutForm from '../../PaymentForm/paymentForm';
import RatingForm from '../Review/ReviewForm';
import Reviews from '../Review/Reviews';
import { Swiper } from 'swiper/react';
import { SwiperSlide } from 'swiper/react';
import { FaStar } from 'react-icons/fa';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
const BookNow = ({ tripData, handleBookingClick, setFormType, setShowForm }) => {
  return (
    <div className="BookNow">
      {/* Price Info */}
      <div className="price-section">
        <div className="price-header">
          <FiDollarSign className="price-icon" />
          <span className="price-label">Starting From</span>
        </div>
        <div className="price-amount">
          ${tripData?.price || "2,590"} <span className="price-unit">per person</span>
        </div>
        <div className="price-note">
          <FiCheckCircle /> All taxes & fees included
        </div>
      </div>

      {/* Action Buttons */}
      <div className="action-buttons">
        <button 
          id="b1" 
          className="book-btn"
          onClick={handleBookingClick}
        >
          <span>BOOK NOW</span>
          <FiChevronRight className="btn-icon" />
        </button>
        <button 
          id="b2" 
          className="enquire-btn"
          onClick={() => { setFormType("enquiry"); setShowForm(true); }}
        >
          ENQUIRE NOW
        </button>
      </div>

      {/* Trip Details */}
      <div className="trip-details">
        <div className="detail-item">
          <FiCalendar />
          <div>
            <span className="label">Duration</span>
            <span className="value">{tripData?.duration || "10 Days"}</span>
          </div>
        </div>
        <div className="detail-item">
          <FiUsers />
          <div>
            <span className="label">Group Size</span>
            <span className="value">{tripData?.groupSize || "4-12 People"}</span>
          </div>
        </div>
        <div className="detail-item">
          <FiStar />
          <div>
            <span className="label">Difficulty</span>
            <span className="value">{tripData?.difficulty || "Moderate"}</span>
          </div>
        </div>
      </div>

      {/* Features Box */}
      <div className="features-box">
        <h4 className="features-title">
          <FiShield /> Why Book With Us
        </h4>
        <ul className="features-list">
          <li><FiCheckCircle /> Secure & Easy Booking</li>
          <li><FiCheckCircle /> Best Price Guaranteed</li>
          <li><FiCheckCircle /> 1000+ Happy Customers</li>
          <li><FiCheckCircle /> 24/7 Customer Support</li>
          <li><FiCheckCircle /> Flexible Cancellation</li>
          <li><FiCheckCircle /> Expert Local Guides</li>
        </ul>
      </div>

      {/* Additional Info */}
      <div className="additional-info">
        <div className="info-item">
          <FiClock /> Instant Confirmation
        </div>
        <div className="info-item">
          <FiUsers /> Group Discounts Available
        </div>
      </div>
    </div>
  );
};

const TripDetailsPage = () => {
  
  const { slug } = useParams()
  const navigate = useNavigate();
  const [tripData, setTripData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showDateSelector, setShowDateSelector] = useState(false);
  const [selectedDate, setSelectedDate] = useState();
  const [showGallery, setShowGallery] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const [formType, setFormType] = useState("");
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    people: 1,
    date: "",
    nationality: "",
    message: "",
    tripName: tripData?.title,
    amount: 0,
  });

  const [bookingData, setBookingData] = useState();

  useEffect(() => {
    getTripBySlug(slug).then((response) => {
      setTripData(response);
      setFormData((prevData) => ({
        ...prevData,
        tripName: response.title
      }));
      setLoading(false);
    }).catch((error) => {
      console.error('Error fetching trip data:', error);
    });
  }, [slug]);


  const handleNextImage = () => {
    setCurrentImageIndex((prev) =>
      prev === tripData?.galleryImages.length - 1 ? 0 : prev + 1
    );
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prev) =>
      prev === 0 ? tripData?.galleryImages.length - 1 : prev - 1
    );
  };
const setAmount = () => {
  const pricePerPerson = selectedDate
    ? Number(selectedDate.price)
    : Number(tripData?.price);

  setFormData(prev => ({
    ...prev,
    amount: pricePerPerson
  }));
};


  // useEffect(() => {
  //   setFormData({
  //     ...formData,
  //     amount: formData.people * (selectedDate ? Number(selectedDate.price): Number(tripData?.price))
  //   })
  // }, [formData.people])
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const setUser = () => {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user"));
    if (!token) {
      navigate(`/login?returnTo=/trips-details/${tripData?.slug}`)
    }
    setFormData((prev) => ({
      ...prev,
      fullName: user.name,
      email: user.email,
      phone: user.phone,
      nationality: user.nationality
    }))
  }
  const handleBookingClick = () => {
    setUser();
    setFormType("booking"); JSON.parse(tripData.variations).length > 0 ? setShowDateSelector(true) : setShowForm(true);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formType === 'booking') {
      setBookingData({
        tripId: tripData._id,
        name: formData.fullName,
        email: formData.email,
        phone: formData.phone,
        totalPersons: formData.people,
        nationality: formData.nationality,
        totalPrice: formData.amount,
        date: formData.date
      })
      setFormType("payment");
    }
  };
  const swiperRef = useRef(null);
  // Swiper configuration
  const swiperParams = {
    spaceBetween: 30,
    slidesPerView: 3,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    pagination: {
      clickable: true,
    },
    navigation: true,
    modules: [Autoplay, Pagination, Navigation],
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      // when window width is >= 768px
      768: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      // when window width is >= 1024px
      1024: {
        slidesPerView: 3,
        spaceBetween: 25
      },
      // when window width is >= 1200px
      1200: {
        slidesPerView: 3,
        spaceBetween: 30
      }
    },
    onSwiper: (swiper) => {
      swiperRef.current = swiper;
    }
  };
const getTotalAmount = () => {
  let total = formData.amount * formData.people;

  if (formData.people >= 6) {
    total -= formData.people * 60;
  } else if (formData.people >= 4) {
    total -= formData.people * 50;
  }

  return total;
};


  return loading ? (
    <div>Loading...</div>
  ) : (
    <div className="Main">
      <Helmet>
        <title>{tripData?.title}</title>
        <meta
          name="description"
          content={tripData?.description}
        />
        <meta
          name="keywords"
          content={tripData?.keywords}
        />
        <meta
          property="og:title"
          content={`${tripData?.title} | World Adventures Tours`}
        />
        <meta
          property="og:description"
          content={tripData?.description}
        />
        <meta
          property="og:image"
          content={`${IMAGE_BASE_URL}/${tripData?.thumbnailImage}`}
        />
        <meta
          property="og:url"
          content={`https://worldadventurestours.com/${slug}`}
        />
        <meta
          property="og:type"
          content="website"
        />
        <link
          rel="canonical"
          href={`https://worldadventurestours.com/${slug}`}
        />
      </Helmet>


      <div className="Slider">
        <div className="Background" onClick={() => setShowGallery(true)}>
          <img crossOrigin='anonymous' src={`${IMAGE_BASE_URL}/${tripData?.thumbnailImage}`} alt="Trip Thumbnail" style={{
            maxHeight: "100vh"
          }} />
        </div>

        <div className="Gallary">
          <button onClick={() => setShowGallery(true)}>Gallery</button>
        </div>

        <div className="Heading">
          <h1>{tripData?.title}</h1>
        </div>

        <div className="Location">
          <div className="day">
            <LuClock9 />
            <strong>{tripData?.duration}</strong>
          </div>
          <div className="city">
            <IoLocationSharp />
            <strong>{tripData.location}</strong>
          </div>
        </div>
      </div>

      {/* <div className="BookNow">
        <button id="b1" onClick={() => { handleBookingClick() }}>
          BOOK NOW
        </button>
        <button id="b2" onClick={() => { setFormType("enquiry"); setShowForm(true); }}>
          ENQUIRE NOW
        </button>

        <div className="box">
          <ol>
            <li><FiChevronRight /> Secure & Easy Booking</li>
            <li><FiChevronRight /> Best Price Guaranteed</li>
            <li><FiChevronRight /> 1000+ Happy Customers</li>
          </ol>
        </div>
      </div> */}

<BookNow
  tripData={tripData}
  handleBookingClick={handleBookingClick}
  setFormType={setFormType}
  setShowForm={setShowForm}
/>


      <div className="NavBar">
        <ul>
          <li className="Item"><a href="#overview" className='navLink'>Overview</a></li>
          <li className="Item"><a href="#Itinerary" className='navLink'>Itinerary</a></li>
          <li className="Item"><a href="#Inclusions" className='navLink'>Inclusions</a></li>
          <li className="Item"><a href="#FAQs" className='navLink'>FAQs</a></li>
          {JSON.parse(tripData.variations).length > 0 && <li className="Item"><a href="#variations" className='navLink'>Available Dates</a></li>}
          <li className="Item"><a href="#reviews" className='navLink'>Reviews</a></li>
          <li className="Item"><a href="#Map" className='navLink'>Map</a></li>
        </ul>
      </div>

      <div className="Body">
        <div className="overview" id="overview">
          <Overview overview={tripData?.overview} />
        </div>

        <br />
        <div className="itinerary" id="Itinerary">
          <h2>K2 Base Camp Trek Itinerary</h2>
          <Itinerary itinerary={tripData.itinerary} />
        </div>

        <br />
        <div className="Inclusion" id="Inclusions">
          <InclusionExclusion inclusions={tripData.inclusions} exclusions={tripData.exclusions} />
        </div>

        <br />
        <div className="Faqs" id="FAQs">
          <FAQs faqsData={tripData?.faqs} />
        </div>

        {
          JSON.parse(tripData.variations).length > 0 &&
          <>
            {/* <h3>Available Dates</h3> */}
            <div className="contactUs" id="variations">
              <Variations variations={tripData?.variations}
              formData={formData}
              setUser={setUser}
              setFormData={setFormData}
                onSelect={(variation) => {
                  console.log(variation)
                  setSelectedDate(variation)                  
                  setFormType("booking")
                  setShowForm(true)
                }} />
            </div>
          </>
        }
      </div>
      
      {/* <div className='reviews' id='reviews'>
        <>
          <h1>Reviews</h1>
          <Swiper {...swiperParams} className="container-reviews">
            {tripData.reviews && tripData.reviews.map((item) => (
              <SwiperSlide key={item.id}>
                <Reviews review={item} />
              </SwiperSlide>
            ))}
          </Swiper>
          <RatingForm itemId={tripData._id} />
        </>
      </div> */}
      <div className="reviews" id="reviews">
  <ReviewsSection
    reviews={tripData?.reviews || []}
    itemId={tripData?._id}
    tripName={tripData?.name}
  />
</div>

      {/* <div className="map" id="Map">
        <Map />
      </div> */}
      {/* Gallery Modal */}
      {showGallery && (
        <div className="gallery-modal">
          <div className="gallery-content">
            <button className="close-btn" onClick={() => setShowGallery(false)}>
              <ImCross />
            </button>
            <button className="prev-btn" onClick={handlePrevImage}>&lt;</button>
            <img crossOrigin='anonymous' src={`${IMAGE_BASE_URL}/${tripData?.galleryImages[currentImageIndex]}`} alt="Gallery" />
            <button className="next-btn" onClick={handleNextImage}>&gt;</button>
          </div>
        </div>
      )}

      {showDateSelector && (
        <DateSelector
          dates={tripData?.variations}
          tripTitle={tripData?.title}
          onClose={() => setShowDateSelector(false)}
          setSelectedDate={setSelectedDate}
          selectedDate={selectedDate}
          setFormData={setFormData}
          formData={formData}
          onSelectDate={(data) => {
            
            setAmount();
            setShowDateSelector(false);
            setShowForm(true);
          }}
        />
      )}

      {/* Booking & Enquiry Form Modal */}
{showForm && (
  <div className="modal-overlay" onClick={() => setShowForm(false)}>
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <div className="header-icon">
          {formType === "booking" ? "📅" : formType === "enquiry" ? "📩" : "💳"}
        </div>
        <div className="header-text">
          <h2>
            {formType === "booking" ? "Complete Your Booking" : 
             formType === "enquiry" ? "Send Your Enquiry" : 
             "Secure Payment"}
          </h2>
          <p className="trip-name">{formData.tripName}</p>
        </div>
        <button className="close-btn" onClick={() => setShowForm(false)}>
          <ImCross />
        </button>
      </div>

      <div className="form-progress">
        <div className={`progress-step ${formType === "booking" ? "active" : ""}`}>
          <span className="step-number">1</span>
          <span className="step-text">Booking Details</span>
        </div>
        <div className="progress-line"></div>
        <div className={`progress-step ${formType === "payment" ? "active" : ""}`}>
          <span className="step-number">2</span>
          <span className="step-text">Payment</span>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="booking-modal-form">
        {formType === "booking" && (
          <>
            <div className="form-section">
              <h3><i className="icon-user"></i> Personal Information</h3>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="fullName">
                    <i className="icon-user-circle"></i> Full Name *
                  </label>
                  <input 
                    type="text" 
                    id="fullName" 
                    name="fullName" 
                    value={formData.fullName} 
                    onChange={handleChange} 
                    placeholder="Enter your full name" 
                    required 
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="nationality">
                    <i className="icon-globe"></i> Nationality *
                  </label>
                  <input 
                    type="text" 
                    id="nationality" 
                    name="nationality" 
                    value={formData.nationality} 
                    onChange={handleChange} 
                    placeholder="Your nationality" 
                    required 
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">
                    <i className="icon-mail"></i> Email Address *
                  </label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email" 
                    value={formData.email} 
                    onChange={handleChange} 
                    placeholder="your.email@example.com" 
                    required 
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="phone">
                    <i className="icon-phone"></i> Phone Number *
                  </label>
                  <input 
                    type="tel" 
                    id="phone" 
                    name="phone" 
                    value={formData.phone} 
                    onChange={handleChange} 
                    placeholder="+1 (234) 567-8900" 
                    required 
                  />
                </div>
              </div>
            </div>

            <div className="form-section">
              <h3><i className="icon-calendar"></i> Trip Details</h3>
              
              <div className="form-group">
                <label htmlFor="date">
                  <i className="icon-calendar-days"></i> Selected Date *
                </label>
                <div className="selected-date-display">
                  <i className="icon-calendar-check"></i>
                  <span>{formData.date || "Select a date"}</span>
                </div>
                <input 
                  type="hidden" 
                  id="date" 
                  name="date" 
                  value={formData.date} 
                  onChange={handleChange} 
                  required 
                />
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="people">
                    <i className="icon-users"></i> Number of Travelers *
                  </label>
                  <div className="people-selector">
                    <button 
                      type="button" 
                      className="counter-btn" 
                      onClick={() => setFormData({...formData, people: Math.max(1, formData.people - 1)})}
                    >
                      −
                    </button>
                    <input 
                      type="number" 
                      id="people" 
                      name="people" 
                      value={formData.people} 
                      onChange={handleChange} 
                      min="1" 
                      max="20" 
                      required 
                      className="people-input"
                    />
                    <button 
                      type="button" 
                      className="counter-btn" 
                      onClick={() => setFormData({...formData, people: formData.people + 1})}
                    >
                      +
                    </button>
                  </div>
                  <small>Group discounts apply for 4+ travelers</small>
                </div>
              </div>
            </div>

            <div className="form-section">
              <h3><i className="icon-credit-card"></i> Pricing Summary</h3>
              <div className="pricing-summary">
                <div className="price-row">
                  <span>Price per person</span>
                  <span>${formData.amount}</span>
                </div>
                <div className="price-row">
                  <span>Travelers × {formData.people}</span>
                  <span>${formData.amount} × {formData.people} = ${getTotalAmount()}</span>
                </div>
                {formData.people >= 4 && formData.people < 6 && (
                  <div className="price-row discount">
                    <span>
                      <i className="icon-tag"></i> Group Discount ($50 per person for 4-5 people)
                    </span>
                    <span>- ${formData.people * 50}</span>
                  </div>
                )}
                {formData.people >= 6 && (
                  <div className="price-row discount">
                    <span>
                      <i className="icon-tag"></i> Group Discount ($60 per person for 6+ people)
                    </span>
                    <span>- ${formData.people * 60}</span>
                  </div>
                )}
<div className="price-row subtotal">
  <span>Subtotal</span>
  <span>${getTotalAmount()}</span>
</div>

 <div className="price-row deposit">
  <span>Advance Deposit (50%) *</span>
  <span>${Math.round(getTotalAmount() * 0.5)}</span>
</div>

                <div className="price-note">
                  <i className="icon-info"></i> * 50% advance required to confirm booking. Balance due 30 days before departure.
                </div>
              </div>
            </div>

            <div className="form-section">
              <div className="form-group">
                <label className="checkbox-label">
                  <input type="checkbox" required />
                  <span>I agree to the <a href="/terms">Terms & Conditions</a> and <a href="/privacy">Privacy Policy</a></span>
                </label>
              </div>
              
              <div className="form-group">
                <label className="checkbox-label">
                  <input type="checkbox" />
                  <span>Subscribe to our newsletter for exclusive deals and travel tips</span>
                </label>
              </div>
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={() => setShowForm(false)}>
                Cancel
              </button>
              <button type="submit" className="btn-primary">
                <i className="icon-lock"></i> Proceed to Payment
                <i className="icon-arrow-right"></i>
              </button>
            </div>
          </>
        )}

        {formType === "enquiry" && (
          <>
            <div className="enquiry-header">
              <div className="info-box">
                <i className="icon-help-circle"></i>
                <p>Have questions? Our travel experts will get back to you within 24 hours.</p>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="enquiryFullName">
                  <i className="icon-user"></i> Your Name *
                </label>
                <input 
                  type="text" 
                  id="enquiryFullName" 
                  name="fullName" 
                  value={formData.fullName} 
                  onChange={handleChange} 
                  placeholder="Enter your name" 
                  required 
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="enquiryEmail">
                  <i className="icon-mail"></i> Email Address *
                </label>
                <input 
                  type="email" 
                  id="enquiryEmail" 
                  name="email" 
                  value={formData.email} 
                  onChange={handleChange} 
                  placeholder="your.email@example.com" 
                  required 
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="enquiryTrip">
                <i className="icon-map"></i> Trip Interested In
              </label>
              <input 
                type="text" 
                id="enquiryTrip" 
                name="tripName" 
                value={formData.tripName} 
                readOnly 
                className="readonly-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="enquiryMessage">
                <i className="icon-message-circle"></i> Your Message *
              </label>
              <textarea 
                id="enquiryMessage" 
                name="message" 
                value={formData.message} 
                onChange={handleChange} 
                placeholder="Tell us about your questions, requirements, preferred dates, group size, or any special requests..."
                rows="6"
                required
              />
              <div className="char-counter">
                {formData.message?.length || 0} / 500 characters
              </div>
            </div>

            <div className="enquiry-tags">
              <p>Common questions:</p>
              <div className="tags-container">
                <button type="button" className="tag" onClick={() => setFormData({...formData, message: formData.message + ' Can you provide more details about the itinerary?'})}>
                  Itinerary details
                </button>
                <button type="button" className="tag" onClick={() => setFormData({...formData, message: formData.message + ' What is included in the package price?'})}>
                  What's included
                </button>
                <button type="button" className="tag" onClick={() => setFormData({...formData, message: formData.message + ' Do you offer private/custom tours?'})}>
                  Custom tours
                </button>
                <button type="button" className="tag" onClick={() => setFormData({...formData, message: formData.message + ' What is the cancellation policy?'})}>
                  Cancellation policy
                </button>
              </div>
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={() => setShowForm(false)}>
                Cancel
              </button>
              <button type="submit" className="btn-primary">
                <i className="icon-send"></i> Send Enquiry
              </button>
            </div>
          </>
        )}

        {formType === "payment" && (
          <div className="payment-section">
            <div className="payment-header">
              <i className="icon-shield"></i>
              <h3>Secure Payment Gateway</h3>
              <p>Your payment information is encrypted and secure</p>
            </div>
            
            <div className="payment-info">
              <div className="payment-summary">
                <div className="summary-item">
                  <span>Trip:</span>
                  <span>{formData.tripName}</span>
                </div>
                <div className="summary-item">
                  <span>Price per person:</span>
                  <span>${formData.amount}</span>
                </div>
                <div className="summary-item">
                  <span>Travelers:</span>
                  <span>{formData.people} person(s)</span>
                </div>
                <div className="summary-item">
                  <span>Selected Date:</span>
                  <span>{formData.date}</span>
                </div>
                <div className="summary-item">
                  <span>Base Amount:</span>
                  <span>${formData.amount * formData.people}</span>
                </div>
                {formData.people >= 4 && formData.people < 6 && (
                  <div className="summary-item discount">
                    <span>Group Discount (4-5 people):</span>
                    <span>- ${formData.people * 50}</span>
                  </div>
                )}
                {formData.people >= 6 && (
                  <div className="summary-item discount">
                    <span>Group Discount (6+ people):</span>
                    <span>- ${formData.people * 60}</span>
                  </div>
                )}
                <div className="summary-item total">
                  <span>Total Amount:</span>
                  <span>
                    ${formData.people >= 6 ? 
                      (formData.amount * formData.people) - (formData.people * 60) : 
                      formData.people >= 4 ? 
                      (formData.amount * formData.people) - (formData.people * 50) : 
                      formData.amount * formData.people}
                  </span>
                </div>
                <div className="summary-item deposit">
                  <span>Amount to Pay Now (50% deposit):</span>
                  <span>
                    ${Math.round((formData.people >= 6 ? 
                      (formData.amount * formData.people) - (formData.people * 60) : 
                      formData.people >= 4 ? 
                      (formData.amount * formData.people) - (formData.people * 50) : 
                      formData.amount * formData.people) * 0.5)}
                  </span>
                </div>
              </div>
            </div>
            
            <div className="payment-container">
              <Elements stripe={stripePromise}>
                <CheckoutForm bookingData={formData} />
              </Elements>
            </div>
            
            <div className="payment-security">
              <div className="security-badges">
                <i className="icon-lock"></i>
                <span>256-bit SSL Encryption</span>
                <i className="icon-shield-check"></i>
                <span>PCI DSS Compliant</span>
              </div>
              <p className="security-note">
                <i className="icon-info"></i> Your payment is processed securely. We never store your card details.
              </p>
            </div>
          </div>
        )}
      </form>
    </div>
  </div>
)}
    </div>
  )

};

export default TripDetailsPage;
